import { connect } from 'react-redux';

import { requestQuantityChangeOrDelete } from 'apps/subscriptions/actions/subscriptions';

import SubscriptionsQuantityInputContainer from '../components/SubscriptionsQuantityInputContainer';

export default connect(
  (state, ownProps) => ({
    quantity: state.subscriptions.subscriptionsBySku[ownProps.sku].quantity,
  }),
  {
    onQuantitySubmit: requestQuantityChangeOrDelete,
  }
)(SubscriptionsQuantityInputContainer);
